/* eslint-disable @typescript-eslint/camelcase */
import {
  CPUBenchmarksSettings,
  EnvironmentMonitoringProps,
} from 'modules/environments/interfaces';

export const initialCPUBenchmarkSettings: CPUBenchmarksSettings = {
  enabled: false,
  execution_interval_minutes: 30,
  duration_seconds: 10,
};

export const buildMonitoringInitialValues = (
  environmentMonitoring: EnvironmentMonitoringProps
): EnvironmentMonitoringProps => ({
  enabled: environmentMonitoring?.enabled,
  cpu_benchmarks:
    environmentMonitoring?.cpu_benchmarks || initialCPUBenchmarkSettings,
});

export const buildMonitoringPayload = (
  values: EnvironmentMonitoringProps,
  isMonitoringEnabled: boolean
) => ({
  enabled: isMonitoringEnabled,
  cpu_benchmarks: {
    ...values.cpu_benchmarks,
    execution_interval_minutes: values.cpu_benchmarks?.enabled
      ? values.cpu_benchmarks.execution_interval_minutes
      : null,
    duration_seconds: values.cpu_benchmarks?.enabled
      ? values.cpu_benchmarks.duration_seconds
      : null,
  },
});
